module.exports = __webpack_public_path__ + "static/media/2020-sh.098fcf5b.jpg";